import { __exports as objectGetOwnPropertySymbols } from './_virtual-object-get-own-property-symbols.js';

var hasRequiredObjectGetOwnPropertySymbols;

function requireObjectGetOwnPropertySymbols () {
	if (hasRequiredObjectGetOwnPropertySymbols) return objectGetOwnPropertySymbols;
	hasRequiredObjectGetOwnPropertySymbols = 1;
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
	return objectGetOwnPropertySymbols;
}

export { requireObjectGetOwnPropertySymbols as __require };
//# sourceMappingURL=node_modules-core-js-internals-object-get-own-property-symbols.js.map
